<template>
  <div :class="$style.wrapper">
    <div>
      <MultiSelect
        v-model="localSelectedStatuses"
        :options="statusOptions"
        placeholder="Filter by status"
        option-label="label"
        option-value="value"
        :class="$style.multiSelect"
        :show-toggle-all="false"
        :max-selected-labels="3"
        style="margin-right: 0.5rem"
        @change="() => $emit('update:selectedStatuses', localSelectedStatuses)"
      />
      <MultiSelect
        v-model="localSelectedCampaigns"
        :options="campaignsOptions"
        placeholder="Filter by campaigns"
        option-label="label"
        option-value="value"
        :class="$style.multiSelect"
        :show-toggle-all="false"
        :max-selected-labels="3"
        @change="() => $emit('update:selectedCampaigns', localSelectedCampaigns)"
      />
    </div>
    <Select
      v-model="localSortOrder"
      :options="sortOptions"
      placeholder="Sort by"
      option-label="label"
      option-value="value"
      @change="() => $emit('update:sortOrder', localSortOrder)"
    />
  </div>
</template>

<script setup>
import { OfferStatus } from "@/modules/Offers/types/types";
import MultiSelect from "primevue/multiselect";
import Select from "primevue/select";
import { ref, watch } from "vue";

import useCampaigns from "@/modules/Offers/hooks/useCampaigns";

defineEmits(["update:sortOrder", "update:selectedStatuses", "update:selectedCampaigns"]);

const props = defineProps({
  sortOrder: {
    type: String,
    default: "startDate",
  },
  selectedStatuses: {
    type: Array,
    default: () => [],
  },
  selectedCampaigns: {
    type: Array,
    default: () => [],
  },
  gameId: {
    type: String,
    required: true,
  },
});

const localSortOrder = ref(props.sortOrder);
const localSelectedStatuses = ref(props.selectedStatuses);
const localSelectedCampaigns = ref(props.selectedCampaigns);

const { campaigns } = useCampaigns(props.gameId);

const sortOptions = [
  { label: "Start Date Ascending (default)", value: "startDate" },
  { label: "End Date Ascending", value: "endDate" },
  { label: "Modified", value: "updatedAt" },
  { label: "Date created", value: "createdAt" },
  { label: "Alphabetical", value: "name" },
  { label: "Status", value: "status" },
];

const statusOptions = [
  { label: "Draft", value: OfferStatus.Draft },
  { label: "Pending", value: OfferStatus.Pending },
  { label: "Published", value: OfferStatus.Published },
  { label: "Terminating", value: OfferStatus.Terminating },
  { label: "Stopped", value: OfferStatus.Stopped },
];

const noCampaignOption = { label: "No campaign", value: "noCampaign" };
const campaignsOptions = ref([noCampaignOption]);

watch(campaigns, (newValue) => {
  if (!newValue) {
    return;
  }

  campaignsOptions.value = [
    noCampaignOption,
    ...newValue.map((campaign) => ({
      label: campaign.name,
      value: campaign.id,
    })),
  ];
});
</script>

<style module>
.wrapper {
  margin-bottom: 1rem;
  display: flex;
  justify-content: space-between;
  width: 100%;
}
</style>
